"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSkeleton = exports.StyledSkeletonInput = void 0;
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var others_1 = require("../../utils/others");
exports.StyledSkeletonInput = styled_components_1.default(antd_1.Skeleton.Input)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.ant-skeleton-width-full {\n    width: 100% !important;\n  }\n\n  &.ant-skeleton-element {\n    display: flex;\n  }\n\n  ", "\n"], ["\n  &.ant-skeleton-width-full {\n    width: 100% !important;\n  }\n\n  &.ant-skeleton-element {\n    display: flex;\n  }\n\n  ",
    "\n"])), function (_a) {
    var width = _a.width;
    return width
        ? "\n    &.ant-skeleton-element {\n      width: " + others_1.toCssUnit(width) + ";\n      .ant-skeleton-input {\n        width: " + others_1.toCssUnit(width) + ";\n        min-width: " + others_1.toCssUnit(width) + ";\n      }\n    }\n  "
        : "";
});
var sizeValue = {
    default: "32px",
    small: "24px",
    large: "40px",
};
exports.StyledSkeleton = styled_components_1.default(antd_1.Skeleton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.ant-skeleton-width-full {\n    width: 100% !important;\n  }\n  .ant-skeleton-title {\n    height: ", ";\n    ", "\n  }\n  .ant-skeleton-paragraph > li {\n    height: ", ";\n    ", "\n  }\n"], ["\n  &.ant-skeleton-width-full {\n    width: 100% !important;\n  }\n  .ant-skeleton-title {\n    height: ", ";\n    ",
    "\n  }\n  .ant-skeleton-paragraph > li {\n    height: ", ";\n    ",
    "\n  }\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? "default" : _b;
    return sizeValue[size];
}, function (_a) {
    var sizeOverwrite = _a.sizeOverwrite;
    return sizeOverwrite ? "height: " + others_1.toCssUnit(sizeOverwrite) + ";" : "";
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? "default" : _b;
    return sizeValue[size];
}, function (_a) {
    var sizeOverwrite = _a.sizeOverwrite;
    return sizeOverwrite ? "height: " + others_1.toCssUnit(sizeOverwrite) + ";" : "";
});
var templateObject_1, templateObject_2;
